export default "__VITE_ASSET__CBPSSqr5__"